import { REQUEST } from "./actions/types/types";

const initialState = {
    request : [],
    total : []
}

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case REQUEST.GET_REQUEST:
            return {
              ...state,
              request: payload.request.data
                ? payload.request.data.result
                : [],
              total: payload.request.data
                ? payload.request.data.total
                : 0,
              status: payload.request.status
                ? payload.request.status
                : payload.request.response.status,
            };

        default:
            return state;
    }
}